import PropTypes from 'prop-types';
import React from 'react';
import Formatter from 'yoda-core-components/lib/helpers/Formatter/Formatter';
import { toCapitalize } from 'yoda-site-components/lib/helpers/Utils/utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './ContactInformation.css';

function ContactInformation({ userFirstName, userLastName, userEmailId, userPhoneNumber, source }) {
    return (
        <div
            className={styles.contactInformation}
            data-automation-id="at-contact-info-main-wrapper"
        >
            <div
                data-automation-id="at-contact-information-title"
                className={
                    source === 'review'
                        ? dt(['font-open-sans-semibold', 'text-medium'])
                        : dt(['font-open-sans-semibold'])
                }
            >
                Contact Information
            </div>
            <div className={`${styles.details} ${dt(['text-small'])}`}>
                <div data-automation-id="at-contact-full-name" data-qm-block="true" data-tlprivate>
                    {`${toCapitalize(userFirstName)} ${toCapitalize(userLastName)}`}
                </div>
                <div
                    className={styles.email}
                    data-automation-id="at-contact-user-email"
                    data-qm-block="true"
                >
                    {userEmailId}
                </div>
                <div
                    is
                    x-ms-format-detection="none"
                    data-automation-id="at-contact-phone-number"
                    data-qm-block="true"
                    data-tlprivate
                    className={dt(['!no-underline'])}
                >
                    {Formatter.format(userPhoneNumber, 0)}
                </div>
            </div>
        </div>
    );
}

ContactInformation.propTypes = {
    userFirstName: PropTypes.string.isRequired,
    userLastName: PropTypes.string.isRequired,
    userEmailId: PropTypes.string.isRequired,
    userPhoneNumber: PropTypes.string.isRequired,
    source: PropTypes.string,
};

ContactInformation.defaultProps = {
    source: '',
};

export default ContactInformation;
